import { IApplicationService } from '../application/interfaces/application.service.interface';
import { BaseComponent } from './component.base';

export class AppComponentBase extends BaseComponent {

    constructor(applicationService: IApplicationService) {
        super(applicationService);

        this.initializeAppAsync();
    }

    public initializeApp(): void {
        this.doInitializeApp();
    }

    public async initializeAppAsync(): Promise<void> {
        await this.doInitializeAppAsync();
    }

    protected doInitializeApp(): void {
    }

    protected async doInitializeAppAsync(): Promise<void> {
    }

}
